export default __webpack_public_path__ + "navigation-examples-building-extrusion-960-9c832fe7a1a24625d0478f148aed5a12.png";